import _BaseAPIService from "../_BaseAPIService"

const instance = _BaseAPIService.instance;


const Usermgmt={
    getUser: async() => {
        try{
            const response = await instance.get("/user");
            console.log("user Info Response: ",response.data);
            return response.data;
        }
        catch(error){
            console.log("Error fetching user Info",error);
            throw error;
        }
    },
    getuserbyid: async(id) => {
        try{
            const response = await instance.get(`/user/${id}`);
            console.log(`User Info (Id : ${id}):`,response.data);
            return response.data();
        }
        catch(err){
            console.error(err);
            throw error;
        }
    },
};

export default Usermgmt;
